import TeamMemberDashboard from './Dashboard';

export default TeamMemberDashboard;
